import { createSlice } from '@reduxjs/toolkit'
import createQueryString from 'src/utils/createQueryString'
import axios from '../../api/index'
import {
  failed,
  warning,
  success,
} from './snackSlice'
import { startLoading, stopLoading } from './loadingSlice'

export const refereeGroupsSlice = createSlice({
  name: 'referee',
  initialState: { list: [], current: {}, refereeGroup: [] },
  reducers: {
    groupsFetched: (state, { payload }) => ({ ...state, list: payload }),
    refereeGroupFetched: (state, { payload }) => ({ ...state, refereeGroup: payload }),
  },
})

export default refereeGroupsSlice.reducer

export const {
  groupsFetched,
  refereeGroupFetched,
} = refereeGroupsSlice.actions

export const getGroups = (params) => (dispatch) => {
  dispatch(startLoading())
  axios.get('referee/group', { params: createQueryString(params) })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(groupsFetched(res?.data.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      // dispatch(failed('مشکل در دریافت فهرست گروه ها'))
    })
}

export const getGroup = (groupId) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'get',
    url: `referee/group/${groupId}`,
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(refereeGroupFetched(res?.data.data))
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message ?? ''))
    })
}

export const deleteGroup = (groupId, callback) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'Delete',
    url: `referee/group/${groupId}`,
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then(() => {
      dispatch(stopLoading())
      if (callback) callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      if (callback) callback()
      // dispatch(failed(e.response.data.message || 'مشکل در حذف گروه'))
    })
}

export const createGroup = (data, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'Post',
    url: 'referee/group',
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(success('گروه با موفقیت ساخت شد'))
      if (callBack) callBack(res?.data.data)
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      // dispatch(failed('مشکل در دریافت فهرست گروه ها'))
    })
}

export const getGroupMembers = (groupId, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'get',
    url: `referee/group/${groupId}`,
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(stopLoading())
      if (callBack) callBack(res?.data.data)
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      // dispatch(failed(e.response.data.message || 'مشکل در دریافت اعضای گروه '))
      if (callBack) callBack()
    })
}

export const addMembers = (members, groupId, callBack) => async (dispatch) => {
  dispatch(startLoading())
  const promises = []
  members.forEach((member) => {
    promises.push(axios({
      method: 'patch',
      url: `referee/${member.userId}/addto/${groupId}`,
      headers: {
        'Content-Type': ' application/json',
      },
      uid: member.userId,
      uname: member.userName,
    }))
    dispatch(success('گروه با موفقیت ویرایش شد'))
  })

  const transferPromises = []
  const rejected = []

  const results = await Promise.allSettled(promises)
  results.forEach((result) => {
    if (result.status === 'rejected') {
      const { uid, uname } = result.reason.config
      if (result.reason.response.status === 409) {
        transferPromises.push(
          axios({
            method: 'put',
            url: `referee/${uid}/update/group/${groupId}`,
            headers: {
              'Content-Type': ' application/json',
            },
            uid,
            uname,
          }),
        )
      } else {
        rejected.push(uid)
      }
    }
  })

  if (transferPromises.length) {
    const transfered = await Promise.allSettled(transferPromises)
    transfered.forEach((result) => {
      if (result.status === 'fulfilled') {
        const { uname } = result.value.config
        dispatch(warning(`داور ${uname} قبلا در گروه دیگری بود و به این گروه منتقل شد`))
      } else {
        const { uid } = result.reason.config
        rejected.push(uid)
      }
    })
  }

  dispatch(stopLoading())

  if (rejected.length) {
    dispatch(warning('در افزودن برخی داورها مشکلی پیش آمد'))
  }

  if (callBack) callBack(rejected)
}

export const deleteMembers = (members, callback) => async (dispatch) => {
  dispatch(startLoading())
  const promises = []
  members.forEach((member) => {
    promises.push(axios({
      method: 'delete',
      url: `referee/${member.userId}`,
      headers: {
        'Content-Type': ' application/json',
      },
      uid: member.userId,
      uname: member.userName,
    }))
    // dispatch(warning('داور با موفقیت حذف شد'))
  })

  const rejected = []

  const results = await Promise.allSettled(promises)
  results.forEach((result) => {
    if (result.status === 'rejected') {
      const { uid } = result.reason.config
      rejected.push(uid)
    }
  })

  if (rejected.length) {
    dispatch(warning('در حذف برخی داورها مشکلی پیش آمد'))
  }
  dispatch(stopLoading())
  if (callback) callback(rejected)
}
